// AdminGate (#602). Strict admin-only route guard that allows the
// authenticated session through only when the resolved permissions
// bundle is exactly the `'ALL'` sentinel from
// `PermissionsService.getPermissions`. Mirrors `PermissionGate`'s
// denied-state UX (existing `states.forbidden*` i18n keys) so admin
// denials look identical to permission denials.
import { Outlet, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../stores/auth.js';
import { ErrorState } from '../ui/index.js';

export function AdminGate() {
  const { t } = useTranslation('common');
  const granted = useAuthStore((s) => s.permissions);
  const navigate = useNavigate();
  if (granted !== 'ALL') {
    return (
      <ErrorState
        title={t('states.forbiddenTitle')}
        text={t('states.forbiddenText')}
        onRetry={() => navigate('/')}
        retryLabel={t('actions.goHome')}
      />
    );
  }
  return <Outlet />;
}
